import React, { Component } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

export default class InputCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputData: {},
      labelFloat: false,
    };
  }
  componentWillMount = () => {
    console.log("props", this.props);
    this.setState({ inputData: this.props.inputData }, () => {
      if (this.state.inputData.defaultValue === undefined) {
        this.setState({ labelFloat: false });
      } else {
        this.setState({ labelFloat: true });
      }
    });
  };
  handleChange = (value, item, event, dataS, optIndex) => {
    dataS[optIndex] = item;
    this.props.onInputChanges(value, item, event, dataS, optIndex);
    this.setState({ labelFloat: true });
  };
  onClean = (event) => {
    this.setState({ labelFloat: false });
  };
  render() {
    return (
      <React.Fragment>
        <div className={this.state.inputData.class + " "}>
          <FormControl
            component="fieldset"
          // error={error}
          >
            <FormLabel className="formlabel" component="legend">
              {this.state.inputData.label}
            </FormLabel>
            {this.state.inputData.options.map((item, optIndex) => {
              return (
                <FormControlLabel
                  key={item.name}
                  className="radio-text"
                  control={<Checkbox color="primary"
                    // defaultValue={
                    //   item.value == undefined ? this.state.inputData.defaultValue === undefined
                    //     ? ""
                    //     : this.state.inputData.defaultValue : item.value
                    // }
                    disabled={item.disabled != undefined ? item.disabled : false}
                    checked={item.value}
                    onChange={(value, item, event) =>
                      this.handleChange(value, item, event, this.state.inputData, optIndex)
                    }
                    onClean={this.onClean} />}
                  label={item.label}
                />
              );
            })}
          </FormControl>
        </div>
      </React.Fragment>
    );
  }
}
